export const featuresType = {
    SET_THEME:'SET_THEME',
    FIX_NAV: 'FIX_NAV',
    SET_DASHBOARD_SIDEBAR:'SET_DASHBOARD_SIDEBAR',
    SHOW_SIDE_MENU:'SHOW_SIDE_MENU',
    SET_SCREEN_SIZE:'SET_SCREEN_SIZE',
    OPEN_MODAL: 'OPEN_MODAL',
    IS_LOADING:'IS_LOADING'
}